import lottie from "lottie-web";

const init = () => {
    // let animations = {};

    // const playAnimationWhenReady = (animName, numTrys = 0) => {

    // 	// Get animation object by name
    // 	const a = animations[animName];

    // 	console.log(a);

    // 	if (a === undefined || a.ready === false) {
    // 		let trys = numTrys++;
    // 		if (trys <= 10) {
    // 			window.setTimeout(playAnimationWhenReady(animName, trys), 3000);
    // 		}
    // 	} else {
    // 		a.animation.play();
    // 	}
    // }

    const rootEL = document.documentElement;
    rootEL.addEventListener("animationReady", (e) => {
        // console.log(e.detail);

        e.detail.play();
    });

    // Set Intersection Observer options
    const isOptions = {
        root: null,
        rootMargin: "0px",
        threshold: [0.1, 1.0],
    };

    // Callback for when elements come into/leave view
    const handleIsCallback = (entries, observer) => {
        entries.forEach((entry) => {
            // console.log(entry);

            // Get element in question
            const el = entry.target;

            // Check to see if animation already played
            const played = el.getAttribute("data-animation-played");

            // If animation not yet played
            if (played === null || played === "false") {
                // Get animation name
                const animName = el.getAttribute("data-animation");

                // If just coming into view...
                if (entry.intersectionRatio > 0) {
                    el.setAttribute("data-animation-played", "true");

                    // Load lottie animation stuff
                    const anim = lottie.loadAnimation({
                        container: el.firstChild, // the dom element that will contain the animation
                        renderer: "svg",
                        loop: false,
                        autoplay: false,
                        path: "lottie/" + animName + ".json", // the path to the animation json
                    });
                    anim.addEventListener("DOMLoaded", (e) => {
                        const loadedEvent = new CustomEvent("animationReady", {
                            detail: anim,
                            bubbles: true,
                        });
                        el.dispatchEvent(loadedEvent);
                    });
                }
            }
        });
    };

    // Initialise observer
    const obs = new IntersectionObserver(handleIsCallback, isOptions);

    // Loop through animation elements
    for (const el of document.querySelectorAll("[data-animation]")) {
        // Observe for when they are visible in viewport
        obs.observe(el);
    }
};

export default init;
